import { IAbstractInitialState } from "../../types/common";
import { TAudioTrack } from "../../types/audioTrack";
import { createSlice } from "@reduxjs/toolkit";
import { addRemoveLike, getAudio } from "../../api/asyncThuncks/audioTracks";
import { RootState } from "../store";

interface IInitialState extends IAbstractInitialState {
  audioTracks: TAudioTrack[];
}

const initialState: IInitialState = {
  loading: "idle",
  audioTracks: [],
  error: "",
};

const audioTracksSlice = createSlice({
  name: "audioTracksSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAudio.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAudio.fulfilled, (state, { payload }) => {
        state.audioTracks = [...payload];
        state.loading = "idle";
      })
      .addCase(getAudio.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      })
      .addCase(addRemoveLike.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(addRemoveLike.fulfilled, (state) => {
        state.loading = "idle";
      })
      .addCase(addRemoveLike.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      });
  },
});

export const selectAudioTracks = (state: RootState): IInitialState =>
  state.audioTracks;

export const {} = audioTracksSlice.actions;

export default audioTracksSlice.reducer;
